import { render, staticRenderFns } from "./itPassport.vue?vue&type=template&id=69fe7ec9"
import script from "./itPassport.vue?vue&type=script&lang=js"
export * from "./itPassport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports